<template>
    <div>
        <h5>Реестр договоров</h5>
        <br />
        <dx-button text="Карточка договора" @click="onClick"></dx-button>
    </div>
</template>

<script setup>
import DxButton from 'devextreme-vue/button';
import router from '@/router';
import { useStore } from 'vuex';

const store = useStore();
const onClick = () => {
    const id = 1445;
    const routeName = 'contract-card-view';
    store.dispatch('internalRoute', { routeName, id });
    router.push({ name: routeName, params: { id } });
};
</script>
